<template>
  <div></div>
</template>

<script>

import router from '../router'

export default {
  name: 'Callback',
  beforeCreate() {
    if (this.$route.query.error) {
      this.$auth.logout({
        returnTo: window.location.origin + `/error?error=${encodeURI(this.$route.query.error)}&error_description=${encodeURI(this.$route.query.error_description)}`
      })
    } else {
      location.hash = '#/'
    }
  }
}
</script>